import React, { Component } from 'react';
import './App.css';
import './Form.css';
import Menu from './MenuContainer';
import Form from './FormContainer';
import { Header, Divider } from 'semantic-ui-react'


/* 
 * Top level React component 
 */

export class App extends Component {

  render() {
    const headerFont = {
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 300
    };
    

    return (
      <div className="App">

        <Menu />

        <header>
          <Header as='h1' style={headerFont} textAlign="center">GaelPhon</Header>
          <Header as='h3' style={headerFont} textAlign="center">Scottish Gaelic grapheme to phoneme converter</Header>
          <Header as='h4' style={headerFont} textAlign="center">Pronunciations of Scottish Gaelic Phonetics</Header>
        </header>
        <Divider hidden={true} />

        <main>

        <div className="Form">
          <Form className="Form"/>
        </div>

        </main>

        <footer>
          <a className="ft" href="https://gaelictools.wordpress.com">Gaelictools</a>
          <p>© { `2017 — ${new Date().getFullYear()}` } Olaf Kl&ouml;cker</p>
        </footer>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js